module.exports = __webpack_public_path__ + "static/img/spain_flag.0511ed7.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/spain_flag.png
// module id = odQE
// module chunks = 1